import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get purchaseInvoice
export const getPurchaseInvoice = createAsyncThunk(
  "purchaseInvoice/getPurchaseInvoice",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getPurchaseInvoice({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all purchaseInvoice
export const getAllPurchaseInvoice = createAsyncThunk(
  "purchaseInvoice/getAllPurchaseInvoice",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllPurchaseInvoice();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("purchaseInvoice/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("purchaseInvoice/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "purchaseInvoice/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPagePurchaseInvoice({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getPurchaseInvoiceById = createAsyncThunk(
  "purchaseInvoice/getPurchaseInvoiceById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseInvoiceById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getPurchaseOrderDetail = createAsyncThunk(
  "purchaseInvoice/getPurchaseOrderDetail",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseOrderDetail(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getPurchaseInvoiceAdditionalChargeList = createAsyncThunk(
  "purchaseInvoice/getPurchaseInvoiceAdditionalChargeList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseInvoiceAdditionalChargeList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create purchaseInvoice
export const createPurchaseInvoice = createAsyncThunk(
  "purchaseInvoice/createPurchaseInvoice",
  async (createData, { rejectWithValue }) => {
    const {
      purchaseInvoiceFromBranch,
      branch,
      voucherDateBs,
      voucherDate,
      purchaseInvoiceDetail,
      grnMain,
      partyAccount,
      narration,
      purchaseInvoiceMainPartyDetails,
      purchaseInvoiceMainVehicleDetail,
      purchaseInvoiceMainAdditionalChargeCost,
      discountAmount,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        purchaseInvoiceFromBranch,
        branch,
        voucherDateBs,
        voucherDate,
        purchaseInvoiceDetail,
        grnMain,
        partyAccount,
        narration,
        purchaseInvoiceMainPartyDetails,
        purchaseInvoiceMainVehicleDetail,
        purchaseInvoiceMainAdditionalChargeCost,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.createPurchaseInvoice(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updatePurchaseInvoice = createAsyncThunk(
  "purchaseInvoice/updatePurchaseInvoice",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const {
      salesOrder,
      indentNo,
      isFromHo,
      requiredDateAd,
      voucherDateBs,
      voucherDate,
      branch,
      status,
      documentsAttach,
      // refVoucher,
      purchaseInvoiceDetails,
      discountAmount,
      grandTotal,
      vatAmount,
    } = values;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        isFromHo,
        requiredDateAd,
        branch,
        status,
        voucherDateBs,
        voucherDate,
        // refVoucher,
        purchaseInvoiceDetails,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.updatePurchaseInvoice(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "purchaseInvoice/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
